import React from 'react';

const Footer = () => {
  return (
    <>
      <footer className="footer-container" style={{
        background: '#000000',
        borderTop: '1px solid #1a1a1a',
        padding: '4rem 5%',
        color: '#888888',
        fontSize: '0.88rem'
      }}>
        <div className="container" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
          gap: '40px',
          marginBottom: '3rem'
        }}>
          <div>
            <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <img
                src="/LOGO.jpeg"
                alt="MITOFORGE"
                style={{
                  height: '40px',
                  width: 'auto',
                  objectFit: 'contain'
                }}
              />
              <span style={{
                color: '#ffffff',
                fontSize: '1.25rem',
                fontWeight: 800,
                letterSpacing: '0.12em'
              }}>
                MITOFORGE<sup style={{ fontSize: '0.45em', fontWeight: 600, verticalAlign: 'super', letterSpacing: 0 }}>®</sup>
              </span>
            </div>
            <p style={{ lineHeight: 1.6, margin: 0, maxWidth: '280px' }}>
              Cordyceps militaris cultivated, sun-dried and third-party lab-tested for safety in Nagercoil, Tamil Nadu.
            </p>
          </div>

          <div>
            <h4 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '0.95rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Navigation</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '10px' }}><a href="/#products" style={{ color: '#888888', textDecoration: 'none' }}>Cordyceps Collection</a></li>
              <li style={{ marginBottom: '10px' }}><a href="/#science" style={{ color: '#888888', textDecoration: 'none' }}>The Science</a></li>
              <li style={{ marginBottom: '10px' }}><a href="/#science" style={{ color: '#888888', textDecoration: 'none' }}>Lab Test Reports</a></li>
              <li><a href="/presentation/index.html" target="_blank" rel="noopener noreferrer" style={{ color: '#888888', textDecoration: 'none' }}>Company Presentation</a></li>
            </ul>
            <h4 style={{ color: '#ffffff', marginBottom: '16px', marginTop: '24px', fontSize: '0.95rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Legal</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '10px' }}><a href="/terms" style={{ color: '#888888', textDecoration: 'none' }}>Terms & Conditions</a></li>
              <li style={{ marginBottom: '10px' }}><a href="/privacy" style={{ color: '#888888', textDecoration: 'none' }}>Privacy Policy</a></li>
              <li style={{ marginBottom: '10px' }}><a href="/shipping" style={{ color: '#888888', textDecoration: 'none' }}>Shipping Policy</a></li>
              <li style={{ marginBottom: '10px' }}><a href="/returns" style={{ color: '#888888', textDecoration: 'none' }}>Returns & Refunds</a></li>
              <li><a href="/disclaimer" style={{ color: '#888888', textDecoration: 'none' }}>Disclaimer</a></li>
            </ul>
            <h4 style={{ color: '#ffffff', marginBottom: '16px', marginTop: '24px', fontSize: '0.95rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Partners</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: '10px' }}><a href="/become-a-seller" style={{ color: '#888888', textDecoration: 'none' }}>Become an Affiliate</a></li>
              <li><a href="/login" style={{ color: '#888888', textDecoration: 'none' }}>Portal Login</a></li>
            </ul>
          </div>

          <div>
            <h4 style={{ color: '#ffffff', marginBottom: '16px', fontSize: '0.95rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Cultivation Unit</h4>
            <p style={{ lineHeight: 1.6, margin: '0 0 10px 0' }}>
              Nagercoil, Kanyakumari District, Tamil Nadu – 629901
            </p>
            <p style={{ margin: '0 0 6px 0', color: '#888888', fontFamily: 'monospace', fontSize: '0.82rem' }}>
              GSTIN: 33HCPPM8780M1ZK
            </p>
            <p style={{ margin: '0 0 16px 0', color: '#888888' }}>
              FSSAI Central licence applied · dispatch via Shiprocket at launch
            </p>
            <h4 style={{ color: '#ffffff', marginBottom: '8px', fontSize: '0.95rem', letterSpacing: '0.05em', textTransform: 'uppercase' }}>Contact Us</h4>
            <p style={{ margin: '0 0 4px 0', color: '#888888' }}>
              <a href="mailto:contact@mitoforge.com" style={{ color: '#888888', textDecoration: 'none' }}>contact@mitoforge.com</a>
            </p>
            <p style={{ margin: 0, color: '#888888' }}>
              <a href="tel:6379508969" style={{ color: '#888888', textDecoration: 'none' }}>+91 63795 08969</a>
            </p>
          </div>
        </div>

        <div className="container" style={{ borderTop: '1px solid #141414', paddingTop: '24px' }}>
          <p style={{ fontSize: '0.72rem', color: '#555555', lineHeight: 1.6, margin: '0 0 18px 0', maxWidth: '900px' }}>
            These statements have not been evaluated by the FDA or FSSAI. Cordyceps products are foods/food
            supplements and are not intended to diagnose, treat, cure or prevent any disease. Research linked on this
            site is on Cordyceps/cordycepin in general and does not constitute a claim about our specific products.
            Products will be offered for sale only after our FSSAI Central licence is issued.
          </p>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '16px',
            fontSize: '0.78rem',
            color: '#666666'
          }}>
            <div>© 2026 Cordinal Mushrooms · MITOFORGE® is a registered trademark of Cordinal Mushrooms.</div>
            <div>Razorpay Payments · Shiprocket Dispatch</div>
          </div>
        </div>
      </footer>

      <style>{`
        @media (max-width: 768px) {
          .footer-container {
            padding: 3rem 16px !important;
          }
        }
      `}</style>
    </>
  );
};

export default Footer;
